import React, { useState, useRef, useEffect } from 'react';
import '../../common/css/site_detail.css';
import '../../common/css/markdown.css';
import {useInterval, createNewTab, toGoogleMap, convertTzDate, utcToLocalDate, parse_metrics_body} from '../../common/app_common.js';
import {getApiSitesSite, putApiSitesSiteConfig, getApiSitesSiteHistory, getApiSitesSiteHistoryCount, delApiSitesSiteHistory,
        getApiSitesSiteAlertStatus, getApiSitesSiteAlertStatusCount
} from '../../common/fetch_api/site';
import {getApiEdgeId, putApiEdgeIdConfig, getApiEdgeIdHistroy, getApiEdgeIdHistroyCount, delApiEdgeIdHistroy,
        getApiEdgeIdAlertStatus, getApiEdgeIdAlertStatusCount, delApiEdgeIdAlertStatus, delApiEdgeIdAlertResolved,getApiEdgeIdMetrics
} from '../../common/fetch_api/edge';
import {getApiConfigTag} from '../../common/fetch_api/configuration';
import {TitleDetail, PageNation, CheckEdgeMetric} from '../../common/component_common.js';
import {DecideWindow} from '../../common/modal_common.js';
import {MediaMonitoringStatus} from '../../pages/sites_list/media.js';
import {SchedulerMonitoringStatus} from '../../pages/sites_list/scheduler.js';
import {RedundantMonitoringStatus} from '../../pages/sites_list/redundant.js';
import {SelectEdgeModal} from '../../pages/dash_board/modals.js';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {BsFillRocketTakeoffFill,  BsCheckCircleFill, BsDisplay, BsLink45Deg, BsGeoAltFill, BsCardList} from "react-icons/bs";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkToc from 'remark-toc';
import rehypeRaw from 'rehype-raw';
import rehypeHighlight from 'rehype-highlight';
import rehypeSanitize from 'rehype-sanitize';
import {TermRefreshContext} from '../../pages/sites_list';

import ReactFlow, { Controls, Background, useNodesState, useEdgesState } from 'reactflow';
import 'reactflow/dist/style.css';

const SiteDetail = ({setPageName, siteInfo, setEdgeInfo}) =>
{
    if(!siteInfo)
    {
        siteInfo = JSON.parse(sessionStorage.getItem('siteInfo'));
    }

    const [detailInfo, setDetailInfo] = useState({type: 'site', info: siteInfo});

    const onClickSite = () =>
    {
        Promise.resolve( getApiSitesSite(siteInfo.name) )
        .then( siteData =>
        {
            setDetailInfo({...detailInfo, type: 'site', info: siteData});
        });
    }

    const onClickEdge = (e) =>
    {
        const edgeId = e.currentTarget.id;
        if (!edgeId) return;
        Promise.resolve( getApiEdgeId(edgeId) )
        .then( edgeData =>
        {
            if (!edgeData) return;
            setDetailInfo({...detailInfo, type: 'edge', info: edgeData});
        });
    }

    const onClickEdgeFromList = (edge) =>
    {
        Promise.resolve( getApiEdgeId(edge.id) )
        .then( edgeData =>
        {
            if (!edgeData) return;
            setDetailInfo({...detailInfo, type: 'edge', info: edgeData});
        });
    }

    const [historyTabIndex, setHistoryTabIndex] = useState('History');

    //siteInfo.edgeList(edgeInfo) 에서의 id로 edgeDetail 의 필요한 객체를 가져오기 위해 2개의 props가 필요함
    return (
        <>
            <TitleDetail siteName={siteInfo.name} setPageName={setPageName}></TitleDetail>
            <div className="d-flex flex-column site-details mt-2">
                <div className="d-flex flex-wrap">
                    <Structure
                        onClickSite={onClickSite}
                        siteInfo={siteInfo}
                        onClickEdge={onClickEdge}
                    >
                    </Structure>
                    <DetailControl detailInfo={detailInfo} setPageName={setPageName} setEdgeInfo={setEdgeInfo} onClickEdgeFromList={onClickEdgeFromList}></DetailControl>
                </div>
                <div className="d-flex flex-wrap">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="section d-flex flex-column memo">
                            <Memo detailInfo={detailInfo}></Memo>
                        </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="section d-flex flex-column history">
                            <HistoryTab tabIndex={historyTabIndex} setTabIndex={setHistoryTabIndex} detailInfo={detailInfo}></HistoryTab>
                            {historyTabIndex==='History'&&<History detailInfo={detailInfo}></History>}
                            {historyTabIndex==='Alert'&&<Alert detailInfo={detailInfo}></Alert>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SiteDetail;

const Structure = ({onClickSite, siteInfo, onClickEdge}) => {

    //getEdgeId 다시 상위로 id 전달

    return (
        <>
        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="section structure-area">
                <div className="d-flex flex-column">
                    <div className="section-title">Structure</div>
                    <div className="d-flex flex-wrap diagram-scroll ap-2">
                        <div className="d-inline site-edge">
                            <SiteEdgeList
                                onClickSite={onClickSite}
                                siteInfo={siteInfo}
                                onClickEdge={onClickEdge}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

const SiteEdgeList = ({onClickSite, siteInfo, onClickEdge}) =>
{
    const OffsetX = 10;
    const OffsetY = 10;

    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);
    // const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), []);

    const [tagList, setTagList] = useState([]);
    const [tagListDone, setTagListDone] = useState(false);

    const getTagList = () =>
    {
        Promise.resolve( getApiConfigTag() )
        .then( data => {
            if( data )
            {
                //tag 를 main, sub 우선으로
                let arr = [];
                for(let item of data)
                {
                    if(item.toLowerCase() === 'main')
                    {
                        arr.push(item);
                    }
                    else if(item.toLowerCase() === 'sub')
                    {
                        arr.push(item);
                    }
                    else
                    {
                        arr.push(item);
                    }

                }
                setTagList([...arr, '']);

                setTagListDone(true);
            }
        });
    }
    
    const makeNode = () =>
    {
        //mAgent, sAgent, rm 노드 만들기
        let nodeObj = [];
        let edgeObj = [];
        let nodeHeight = 0;

        // ms 노드 한 컬럼당 너비: edge-box(20) + margin(8) + edge-label(135) = 163px
        const COL_WIDTH = 163;
        const NODE_PADDING = 8;
        const RM_GAP = 30;

        // rm 이 하나라도 있으면 site 노드를 위쪽에 배치, 없으면 기존처럼 같은 줄
        const hasAnyRm = siteInfo.edgeList.some(x => x.type === 'rm');
        const SITE_ROW_HEIGHT = hasAnyRm ? 40 : 0;
        const MS_NODE_X = hasAnyRm ? OffsetX : OffsetX + 120;

        nodeObj.push(
            {
                id: siteInfo.name,
                data: {
                    label: (<div ref={siteRef} className='site-node' onClick={onClickSitePre}>{siteInfo.name}</div>),
                },
                type: 'input',
                sourcePosition: 'right',
                position: { x: OffsetX, y: OffsetY }
            },
        )

        for(let tag of tagList)
        {
            let max = 1;
            const mAgentEdge = siteInfo.edgeList.filter((x) => {return x.tag === tag && x.type === 'm-agent'});
            const sAgentEdge = siteInfo.edgeList.filter((x) => {return x.tag === tag && x.type === 's-agent'});
            const rAgentEdge = siteInfo.edgeList.filter((x) => {return x.tag === tag && x.type === 'r-agent'});
            const rmEdge = siteInfo.edgeList.filter((x) => {return x.tag === tag && x.type === 'rm'});

            // ms 노드 컬럼 수에 따라 rm 노드 x 위치를 동적으로 계산
            const msColumns = [mAgentEdge, sAgentEdge, rAgentEdge].filter(a => a.length > 0).length;
            const msNodeWidth = Math.max(msColumns * COL_WIDTH + NODE_PADDING, 160);
            const rmNodeX = MS_NODE_X + msNodeWidth + RM_GAP;

            //edge가 있을때만 노드 생성
            if(mAgentEdge.length > 0 || sAgentEdge.length > 0 || rAgentEdge.length > 0 )
            {
                nodeObj.push(
                    {
                        id: `ms-${tag}`,
                        data: {
                            label: (
                                <div className="d-flex flex-column">
                                    <div className="node-header">{`${tag.replace(/\b[a-z]/g, char => char.toUpperCase())} ${rAgentEdge.length > 0 ? '(Packager -> Scheduler -> Redundant)' : '(Packager -> Scheduler)'}`}</div>
                                    <div className="d-flex node-body">
                                        <AgentComp agentArr={mAgentEdge} type={'M'} edgeRef={edgeRef} onClickEdgePre={onClickEdgePre} />
                                        <AgentComp agentArr={sAgentEdge} type={'S'} edgeRef={edgeRef} onClickEdgePre={onClickEdgePre} />
                                        <AgentComp agentArr={rAgentEdge} type={'R'} edgeRef={edgeRef} onClickEdgePre={onClickEdgePre} />
                                    </div>
                                </div>
                            )
                        },
                        type: 'input',
                        sourcePosition: 'right',
                        position: { x: MS_NODE_X, y: OffsetY + SITE_ROW_HEIGHT + nodeHeight }
                    }
                );
                max = Math.max( mAgentEdge.length, sAgentEdge.length, rAgentEdge.length );
            }

            if( rmEdge.length > 0 )
            {
                nodeObj.push(
                    {
                        id: `rm-${tag}`,
                        data: {
                        label: (
                            <div className="d-flex flex-column">
                                <div className="node-header">{`${tag.replace(/\b[a-z]/g, char => char.toUpperCase())} (Transmitter)`}</div>
                                <div className="d-flex rm-node node-body">
                                    <AgentComp agentArr={rmEdge} type={'T'} edgeRef={edgeRef} onClickEdgePre={onClickEdgePre}/> 
                                </div>
                            </div>
                        )
                        },
                        type: 'output',
                        targetPosition: 'left',
                        position: { x: rmNodeX, y: OffsetY + SITE_ROW_HEIGHT + nodeHeight }
                    }
                );
                max = Math.max( max, rmEdge.length );
            }
            
            if( (mAgentEdge.length > 0 || sAgentEdge.length > 0 || rAgentEdge.length > 0) && rmEdge.length > 0 )
            {
                edgeObj.push(
                    {
                        id: `edge-${tag}`,
                        source: `ms-${tag}`,
                        target: `rm-${tag}`,
                        // animated: true,
                        // type: "smoothstep",
                    },
                )
            }

            if( mAgentEdge.length > 0 || sAgentEdge.length > 0 || rAgentEdge.length > 0 || rmEdge.length > 0 )
            {
                nodeHeight += 30 + (max * 30 );
            }
        }

        setNodes(nodeObj);
        setEdges(edgeObj);
    }


    const siteRef = useRef(null);
    //onclick 되는 요소를 ref 에 배열로 저장해서, 위 id 가 같은 요소 child 에 class 토글.
    const edgeRef = useRef([]);

    const onClickSitePre = (e) =>
    {
        onClickSite(e);

        siteRef.current.classList.add('clicked-edge');

        //site 가 클릭이 되면 다른 edge 에 remove class
        for( const ref of edgeRef.current )
        {
            ref.children[1].classList.remove('clicked-edge');
        }
    }

    const onClickEdgePre = (e) =>
    {
        onClickEdge(e);

        const clickedId = e.currentTarget.id;
        for( const ref of edgeRef.current )
        {
            if (!ref.children[1]) continue;
            if( ref.id === clickedId )
            {
                ref.children[1].classList.add('clicked-edge');
            }
            else
            {
                ref.children[1].classList.remove('clicked-edge');
            }
        }

        //edge 이 클릭이 되면 site 의 class remove
        siteRef.current.classList.remove('clicked-edge');
    }
    
    const defaultViewport = { x: 20, y: 10, zoom: 1.1 };

    useEffect(() => 
    {
        getTagList();
    }, []);

    useEffect(() =>
    {
        if(tagListDone)
        {
            makeNode();
        }
    }, [tagListDone])

    return (
        <ReactFlow
            nodes={nodes}
            edges={edges}
            // style={{ cursor: "pointer" }}
            // onNodesChange={onNodesChange}  //node 드래그 가능
            // onEdgesChange={onEdgesChange}  //선을 연결하는것 가능
            // onConnect={onConnect}
            // onInit={onInit}
            // fitView
            defaultViewport={defaultViewport}
            // onNodeClick={onNodeClick}
            proOptions={{hideAttribution: true}}
            >
            <Controls showInteractive={false}/>
            <Background color="#aaa" gap={16} />
        </ReactFlow>
    );
}

const AgentComp = ({agentArr, type, edgeRef, onClickEdgePre}) =>
{
    const [update, setUpdate] = useState(false);
    const [edgeNodeHtml, setEdgeNodeHtml] = useState();

    function runUpdate()
    {
        setUpdate(!update);
    }
    
    useEffect(() =>
    {
        // console.log(edgeRef.current)
        // edgeRef.current = [];
        makeEdgeNode();
    },[update])

    useInterval(() =>
    {
        runUpdate();
    }, 5000 );

    function addEdge(el)
    {
        //edgeRef 에 null 이 추가되는 현상때문에..
        if( !el ) return;

        let push = true;

        if( edgeRef.current.length > 0 )
        {
            const filter = edgeRef.current.filter((x) => {return x.id === el.id});
            if( filter.length > 0 )
            {
                push = false;
            }
        }

        if(push)
        {
            edgeRef.current.push(el);
        }
    }

    const makeEdgeNode = () =>
    {
        let html = [];

        html.push( agentArr.map((item, index) => (
            <div className='d-flex' ref={el => {addEdge(el)}} key={item.id} id={item.id} onClick={(e) => onClickEdgePre(e)}>
                <div className={`no-click edge-box bg-${item.severity}`}>{type}</div>
                <div className={`no-click edge-label`}>{item.name}</div>
            </div>
        )));

        setEdgeNodeHtml(html);
    }

    return (
        <div className="d-flex flex-column">
            {edgeNodeHtml}
        </div>
    )
}

const DetailControl = ({detailInfo, setPageName, setEdgeInfo, onClickEdgeFromList}) =>
{
    const term = 1;
    const refresh = 5000;
    const isStop = false;
    const isCalendar = false;
    const reload = false;

    const coordinates = useRef(`${detailInfo.info.latitude}, ${detailInfo.info.longitude}`);

    const gotoMonitoringPage = () =>
    {
        setPageName(detailInfo.info.type === 'm-agent' ? 'mediaMonitoring' :
                    detailInfo.info.type === 's-agent' ? 'schedulerMonitoring' :
                    detailInfo.info.type === 'r-agent' ? 'redundantMonitoring' : 'transmitterMonitoring');

        setEdgeInfo(detailInfo.info);

        sessionStorage.setItem('edgeInfo', JSON.stringify(detailInfo.info));
    }

    const onClickGoogleMap = () =>
    {
        coordinates.current = `${detailInfo.info.latitude}, ${detailInfo.info.longitude}`;
        toGoogleMap(coordinates.current);
    }

    const [detailEdgeList, setDetailEdgeList] = useState([]);
    const [selectEdgeModal, setSelectEdgeModal] = useState(false);

    const [alertStatusSeverity, setAlertStatusSeverity] = useState('');

    const onClickEdgeList = () =>
    {
        if(detailInfo.info.edgeList.length > 1)
        {
            setDetailEdgeList(detailInfo.info.edgeList);
            setSelectEdgeModal(true);
        }
    }

    const cloaseSelectEdgeModal = () => setSelectEdgeModal(false);

    const [metricsObj, setMetricsObj] = useState(null);

    const [update, setUpdate] = useState(false);

    function runUpdate()
    {
        setUpdate(!update);
    }
    
    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    useEffect(() =>
    {
        if (detailInfo.type === 'edge')
        {
            Promise.resolve(getApiEdgeIdMetrics(detailInfo.info.id))
            .then(data =>
            {
                let parseBody = parse_metrics_body(data);
                setMetricsObj(parseBody.metrics);
            });
        }

        setAlertStatusSeverity(detailInfo.info.severity);
    }, [update, detailInfo, detailInfo.info.severity]);

    return (
        <TermRefreshContext.Provider value={{term, refresh, isStop, isCalendar, reload}}>
        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="section detail-control-area">
                <div className="d-flex">
                    <div className="col-6">
                        <div className="section-title">{detailInfo.type === 'edge' ? 'Edge Name' : 'CallSign'}</div>
                        <div className="section-title name-info ms-2">{detailInfo.info.name}</div>
                        {detailInfo.info.id && <CheckEdgeMetric edgeId={detailInfo.info.id} />}
                    </div>
                    <div className="col-6">
                        <div className="section-title">Alert Status</div>
                        <div className={`section-title name-info ms-2 text-${alertStatusSeverity}`}>{alertStatusSeverity.replace(/^[a-z]/, char => char.toUpperCase())}</div>
                    </div>
                </div>
                {detailInfo.type === 'edge' ?
                    <>
                        {detailInfo.info.type === 'rm' ? null : <div className="section-title">Status</div>}
                        {detailInfo.info.type === 'm-agent' ?
                            (detailInfo.info.id && <MediaMonitoringStatus key={detailInfo.info.id} pageName={'subPage'} edgeId={detailInfo.info.id}/>) :
                            detailInfo.info.type === 's-agent' ?
                            (detailInfo.info.id && <SchedulerMonitoringStatus key={detailInfo.info.id} pageName={'subPage'} edgeId={detailInfo.info.id}/>) :
                            detailInfo.info.type === 'r-agent' ?
                            (detailInfo.info.id && <RedundantMonitoringStatus key={detailInfo.info.id} pageName={'subPage'} edgeId={detailInfo.info.id}/>) :
                            null
                        }
                    </> :
                    <></>}
                <div className="section-title">View</div>
                <div className="d-flex flex-column ms-2 mt-2">
                    <div className='d-flex'>
                    {detailInfo.type === 'site' ?
                        <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Edge List" onClick={onClickEdgeList}><BsCardList /></Button>
                        :
                        <>
                        <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Go to Monitoring" onClick={gotoMonitoringPage}><BsDisplay /></Button>
                        <Button variant='primary' className="btn btn-icon ms-2" data-bs-toggle="tooltip" title="Link to Device" onClick={() => {createNewTab(detailInfo.info.link)}}><BsLink45Deg /></Button>
                        </>
                    }
                        <Button variant='primary' className="btn btn-icon ms-2" data-bs-toggle="tooltip" title="Location" onClick={onClickGoogleMap}><BsGeoAltFill /></Button>
                    </div> 
                </div>
            </div>
            {selectEdgeModal&&<SelectEdgeModal edgeInfo={detailEdgeList} result={onClickEdgeFromList} show={selectEdgeModal} handleClose={cloaseSelectEdgeModal}></SelectEdgeModal>}
        </div>
        </TermRefreshContext.Provider>
    )
}

const HistoryTab = ({tabIndex, setTabIndex, detailInfo}) =>
{
    return (
        <Tabs
            defaultActiveKey="History"
            transition={true}
            activeKey={tabIndex}
            onSelect={(k) => setTabIndex(k)}
            className="mt-2" >
            <Tab eventKey="History" title={detailInfo.type === 'site' ? "History (Site)" : "History (Edge)"}/>
            <Tab eventKey="Alert" title="Alert"/>
        </Tabs>
    )    
}

const History = ({detailInfo}) =>
{
    const [tableSpinner, setTableSpinner] = useState(false);
    const [pageSelCount, setPageSelCount] = useState(0);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);
    const PAGE_PER = 8;

    const [html, setHtml] = useState(null);

    const getHistory = () =>
    {
        curPageRef.current.value = curPageState;
    
        const countApiCall = detailInfo.type === 'site' ? getApiSitesSiteHistoryCount : getApiEdgeIdHistroyCount;
        const historyApiCall = detailInfo.type === 'site' ? getApiSitesSiteHistory : getApiEdgeIdHistroy;
    
        Promise.resolve(countApiCall(detailInfo.type === 'site' ? detailInfo.info.name : detailInfo.info.id))
        .then(data =>
        {
            if (data.hasOwnProperty('count'))
            {
                setPageSelCount(Math.max(data.count, 1));

                return Promise.resolve(historyApiCall(detailInfo.type === 'site' ? detailInfo.info.name : detailInfo.info.id, PAGE_PER, curPageState));
            }
            else
            {
                return [];
            }
        })
        .then(data => {
            setHtml(data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            setHtml([]);
        })
        .finally(() => {
            setTimeout(() => { setTableSpinner(false); }, 700);
        });
    };
    

    const onClickClearHistory = () =>
    {
        if(detailInfo.type === 'site')
        {
            Promise.resolve( delApiSitesSiteHistory(detailInfo.info.name) )
            .then( data =>
            {
                callGetHistory(true);
            });
        }
        else if(detailInfo.type === 'edge')
        {
            Promise.resolve( delApiEdgeIdHistroy(detailInfo.info.id) )
            .then( data =>
            {
                callGetHistory(true);
            });
        }
    }

    function callGetHistory(initPage)
    {
        setTableSpinner(true);
        getHistory();
        if( initPage )
        {
            setCurPageState(1);
        }
    }

    const firstLoading = useRef(true);
    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            callGetHistory(true);
        }
    }, [detailInfo.info.name, detailInfo.info.id]);
    
    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            callGetHistory(false);
        }
    }, [curPageState]);

    useEffect(() =>
    {
        callGetHistory(true);
        firstLoading.current = false;
    }, []);

    useInterval(() =>
    {
        callGetHistory(false);
    }, 10000 );

    return (
        <>
        <div className="tab-pane show active position-relative">
            {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
            <div className="d-flex flex-column">
            <div className="d-flex justify-content-end my-2">
                <Button variant="primary" className="btn btn-sm" onClick={onClickClearHistory}>Clear History</Button>
            </div>
            <div className="history timeline">
                <div className="outer">
                    {html && html.map((item, index)=>(
                        <div className="card" key={index}>
                            <div className="history-info">
                                <div className="issue-date">{utcToLocalDate(convertTzDate(item.date))}</div>
                                <div>{item.log}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setCurPageState}
                selCount={pageSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
            </div>
        </div>
        </>
    )
}

const Alert = ({detailInfo}) =>
{
    const [modalClearResolved, setModalClearResolved] = useState(false);
    const [modalClearAlert, setModalClearAlert] = useState(false);
    const closeModalClearResolved = () => setModalClearResolved(false);
    const closeModalClearAlert = () => setModalClearAlert(false);
    const [decideBtn, setDecideBtn] = useState('OK');
    const [decideBody, setDecideBody] = useState(null);

    const [tableSpinner, setTableSpinner] = useState(false);
    const [pageSelCount, setPageSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);
    const PAGE_PER = 8;

    const [html, setHtml] = useState(null);

    function firingStatus(value)
    {
        let status = '';
        if(value === 'firing')
        {
            status = <BsFillRocketTakeoffFill className="text-info" />;
        }
        else if(value === 'resolved')
        {
            status = <BsCheckCircleFill className="text-good" />;
        }

        return status;
    }

    const handleAlertData = async (countApiCall, alertApiCall, infoKey) =>
    {
        try {
            const countData = await Promise.resolve(countApiCall());

            if (countData.hasOwnProperty('count'))
            {
                setPageSelCount(Math.max(countData.count, 1));

                const alertData = await Promise.resolve(alertApiCall());

                const html = alertData.map((item, i) =>
                (
                    <div className="card" key={i}>
                        <div className="history-info">
                            <div className={`timeline-${item.severity} issue-date`}>{utcToLocalDate(convertTzDate(item.date))}</div>
                            <div>{firingStatus(item.status)}</div>
                            <div className={`text-${item.severity}`}>{item.labels.edgeName}</div>
                            <div> | </div>
                            <div className={`text-${item.severity}`}>{item.labels.summary}</div>
                            <div> | </div>
                            <div className={`text-${item.severity}`}>{item.labels.message}</div>
                        </div>
                    </div>
                ));
                setHtml(html);
            }
            else
            {
                setHtml(null);
            }
        }
        catch (error)
        {
            console.error('Error fetching data:', error);
        }
        finally
        {
            setTimeout(() => { setTableSpinner(false); }, 700);
        }
    };

    const getAlert = () =>
    {
        curPageRef.current.value = curPageState;
    
        if (detailInfo.type === 'site')
        {
            handleAlertData(
                () => getApiSitesSiteAlertStatusCount(detailInfo.info.name),
                () => getApiSitesSiteAlertStatus(detailInfo.info.name, PAGE_PER, curPageState, 'desc')
            );
        }
        else if (detailInfo.type === 'edge')
        {
            handleAlertData(
                () => getApiEdgeIdAlertStatusCount(detailInfo.info.id, ''),
                () => getApiEdgeIdAlertStatus(detailInfo.info.id, PAGE_PER, curPageState, '', 'desc')
            );
        }
    };

    const onClickClearResolved = (result) =>
    {
        if(result)
        {
            Promise.resolve( delApiEdgeIdAlertResolved(detailInfo.info.id) )
            .then( data =>
            {
                callGetAlert(true);
            });
        }
    }

    const onClickClearAlert = (result) =>
    {
        if(result)
        {
            Promise.resolve( delApiEdgeIdAlertStatus(detailInfo.info.id) )
            .then( data =>
            {
                callGetAlert(true);
            });
        }
    }

    function callGetAlert(initPage)
    {
        setTableSpinner(true);
        getAlert();
        if( initPage )
        {
            setCurPageState(1);
        }
    }

    const firstLoading = useRef(true);
    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            callGetAlert(true);
        }
    }, [detailInfo.info.name, detailInfo.info.id]);

    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            callGetAlert(false);
        }
    }, [curPageState]);

    useEffect(() =>
    {
        callGetAlert(true);
        firstLoading.current = false;
    }, []);

    useInterval(() =>
    {
        callGetAlert(false);
    }, 10000 );

    const showModalClear = (modalType) =>
    {
        setDecideBtn('Clear');
        setDecideBody(
            <div className='text-center'>
                <p>Would you like to clear this?</p>
            </div>
        );
    
        if (modalType === 'resolved')
        {
            setModalClearResolved(true);
        }
        else if (modalType === 'alert')
        {
            setModalClearAlert(true);
        }
    }

    return (
        <>
        <div className="tab-pane show active position-relative">
            {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
            <div className="d-flex flex-column">
            <div className="d-flex justify-content-end my-2">
                {detailInfo.type === 'edge' ? <Button variant="primary" className="btn btn-sm" onClick={() => showModalClear('resolved')}>Clear Resolved</Button> : ''}
                {detailInfo.type === 'edge' ? <Button variant="primary" className="btn btn-sm ms-2" onClick={() => showModalClear('alert')}>Clear Alert</Button> : ''}
            </div>
            <div className="alert timeline">
                <div className="outer">
                    {html}
                </div>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setCurPageState}
                selCount={pageSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
            </div>
        </div>
        {modalClearResolved&&<DecideWindow result={onClickClearResolved} show={modalClearResolved} handleClose={closeModalClearResolved} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
        {modalClearAlert&&<DecideWindow result={onClickClearAlert} show={modalClearAlert} handleClose={closeModalClearAlert} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
        </>
    )
}

const Memo = ({detailInfo}) =>
{
    const memoText = useRef('');

    const [tabIndex, setTabIndex] = useState('Memo');
    const [markDown, setMarkDown] = useState('');
    const [siteMemoLen, setSiteMemoLen] = useState(0);

    const onChangeInputMemo = (e) =>
    {
        setMarkDown(e.target.value);
        setSiteMemoLen(e.target.value.length);
        memoText.current.value = e.target.value;
    }

    const onClickSave = () =>
    {
        if(detailInfo.type === 'site')
        {
            let sendData = {
                'market': detailInfo.info.market,
                'latitude': detailInfo.info.latitude,
                'longitude': detailInfo.info.longitude,
                'frequency': detailInfo.info.frequency,
                'excLatitude': detailInfo.info.excLatitude,
                'excLongitude': detailInfo.info.excLongitude,
                'transmissionStations': detailInfo.info.transmissionStations,
                'memo': memoText.current.value
            }

            Promise.resolve( putApiSitesSiteConfig(detailInfo.info.name, sendData) )        
            .then( done =>
            {
                setTabIndex('Memo');
            });
        }
        else if(detailInfo.type === 'edge')
        {
            let sendData = {
                'longitude': detailInfo.info.longitude,
                'latitude': detailInfo.info.latitude,
                'locationMode': detailInfo.info.locationMode,
                'transmissionStation': detailInfo.info.transmissionStation,
                'memo': memoText.current.value,
                'link': detailInfo.info.link,
                'tag': detailInfo.info.tag
            }

            Promise.resolve( putApiEdgeIdConfig(detailInfo.info.id, sendData) )        
            .then( done =>
            {
                setTabIndex('Memo');
            });
        }
    }

    const onClickCancel = () =>
    {
        setMarkDown(detailInfo.info.memo);
        memoText.current.value = detailInfo.info.memo;
    }

    //textare 는 이벤트를 받아서 표시하려면 defaultValue 사용 - 그러면 글쓰기가 안됨.
    //value 로 처리하면 편집은 되지만 상단에서 이벤트를 주어서 memoInfo를 받아서 표시가 안됨
    //그래서 useEffect로 변경되는 값을 다음과 같이 처리 하였음.
    useEffect(() =>
    {
        const memo = detailInfo.info.memo ?? '';
        setMarkDown(memo);
        setSiteMemoLen(memo.length);
        memoText.current.value = memo;
    },[detailInfo.info.memo]);

    return (
        <>
            <Tabs
                defaultActiveKey="Memo"
                transition={true}
                activeKey={tabIndex}
                onSelect={(k) => setTabIndex(k)}
                className="mt-2" >
                <Tab eventKey="Memo" title="Memo"/>
                <Tab eventKey="Editor" title="Editor"/>
            </Tabs>
            <div className={`mt-2 ${tabIndex === 'Memo'?'':'d-none'}`} >
                <ReactMarkdown className='mark-down form-control markdown-body'
                    children={markDown}
                    remarkPlugins={[remarkGfm, remarkToc]}
                    rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
                />
            </div>
            <div className={`mt-2 ${tabIndex === 'Editor'?'':'d-none'}`} >
                <textarea className="mark-down form-control" maxLength="65535" ref={memoText} onChange={onChangeInputMemo} defaultValue={detailInfo.info.memo}></textarea>
                <div className="text-end">{`${siteMemoLen} / 65535`}</div>
                <div className="d-flex justify-content-end mt-2">
                    <button type="button" className="btn btn-secondary btn-sm" onClick={onClickCancel}>Cancel</button>
                    <button type="button" className="btn btn-primary btn-sm ms-2" onClick={onClickSave}>Save</button>
                </div>
            </div>
        </>
    )
}